// extracted by mini-css-extract-plugin
module.exports = {"a":"Anchor__a___1_Iz8"};


// WEBPACK FOOTER //
// ./webpack:/aws_amplify_ui/src/Anchor.css?a212